module.exports = "/_next/static/images/c9a13e340ccf4528cbec397249c8bebb-yield.png";